/**
 * Tooltip component
 *
 * @module tooltip-component
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "tooltip-component";

if (!customElements.get(customElements.component)) {
  class Tooltip extends HTMLElement {
    /**
     * Tooltip Web Component
     *
     * @constructor
     */
    constructor() {
      super();
      this.build();
    }

    /**
     * Build component actions
     *
     * @returns {undefined}
     */
    build() {
      this._show = this._show.bind(this);
      this._hide = this._hide.bind(this);
      this.style.position = 'absolute';
    }

    connectedCallback() {
      this._hide();
      this._target = document.querySelector(`[data-target-tooltip=${this.id}]`);
      if (this._target) this.createTargetListeners();
    }

    disconnectedCallback() {
      if (this._target) this.removeTargetListeners();
    }

    /**
     * Create event listeners on target
     *
     * @returns {undefined}
     */
    createTargetListeners() {
      if ("hover" in this.dataset && this.dataset.hover !== "false") {
        this._target.addEventListener("mouseenter", this._show);
        this._target.addEventListener("mouseleave", this._hide);
      }
      this._target.addEventListener("focus", this._show);
      this._target.addEventListener("blur", this._hide);
    }

    /**
     * Remove event listeners on target
     *
     * @returns {undefined}
     */
    removeTargetListeners() {
      if ("hover" in this.dataset && this.dataset.hover !== "false") {
        this._target.removeEventListener("mouseenter", this._show);
        this._target.removeEventListener("mouseleave", this._hide);
      }
      this._target.removeEventListener("focus", this._show);
      this._target.removeEventListener("blur", this._hide);
      this._target = null;
    }

    /**
     * Show Tooltip on screen
     *
     * @returns {undefined}
     */
    _show() {
      this.style.display = "block";
    }

    /**
     * Hide Tooltip on screen
     *
     * @returns {undefined}
     */
    _hide() {
      if (this._target === document.activeElement) return;
      this.style.display = "none";
    }
  }

  customElements.define(customElements.component, Tooltip);
}
